import { C, F } from '../tokens';

export function EmptyState({ icon, title, text }: { icon: string; title: string; text: string }) {
  return (
    <div style={{ textAlign: 'center', padding: '50px 20px', color: C.sub }}>
      <div style={{ fontSize: 32, marginBottom: 12 }}>{icon}</div>
      <div style={{ fontFamily: F.head, fontWeight: 700, fontSize: 16, color: C.sub }}>{title}</div>
      <div style={{ fontSize: 11, marginTop: 5, color: C.dim }}>{text}</div>
    </div>
  );
}
